import React from "react";
import { NavigationProvider } from "./context/NavigationContext";
import { useActiveSection } from "./hooks/useActiveSection";
import WhatsAppWidget from "./components/WhatsAppWidget";
import Navbar from "./components/Navbar";
import Carousel from "./components/Carousel";
import About from "./components/About";
import Products from "./components/Products";
import Article from "./components/Article";
import Store from "./components/Store";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Copyright from "./components/Copyright";
import BackToTop from "./components/BackToTop";
import { useTranslation } from "react-i18next";
import PartnerSection from "./components/Partners";
const AppContent = () => {
  useActiveSection();
  const { i18n } = useTranslation();

  const isRTL = i18n.language === "ar";
  return (
    <div className="App" dir={isRTL ? "rtl" : "ltr"}>
      {/* <Spinner /> */}
      <Navbar />

      <section id="home" data-section="home">
        <Carousel />
      </section>

      <section id="article" data-section="article">
        <About />
      </section>

      <section id="store" data-section="store">
        <Store />
      </section>

      <section id="about" data-section="about">
        <Article />
      </section>

      <section id="partner" data-section="partner">
        <PartnerSection />
      </section>

      <section id="products" data-section="products">
        <Products />
      </section>
      <section id="contact" data-section="contact">
        <Contact />
      </section>

      <Footer />
      <Copyright />
      <BackToTop />
      {/* زر واتساب */}
      <WhatsAppWidget />
    </div>
  );
};

function App() {
  return (
    <NavigationProvider>
      <AppContent />
    </NavigationProvider>
  );
}

export default App;
